import React, { useRef, useState } from "react";
import ConfirmationDialog from "../confirmation-dialog/ConfirmationDialog";
import { useCallbackPrompt } from "~/hooks/useCallbackPrommpt";
import ShareholdersForm from "./ShareholdersForm";

const AddShareholder = () => {
  const { current: initialShareholderData } = useRef({
    type: "",
    name: "",
    other_name: "",
    last_name: "",
    preferred_name: "",
    legal_name: "",
    email: "",
    phone: "",
    phone_code: "",
    point_of_contact: "",
    status: "",
    nationality: "",
    date_of_birth: "",
    contact_email: "",
    tax_identification_no: "",
    local_tax_id: "",
    company_registration_no: "",
    legal_structure: "",
    incorporation_country: "",
  });
  const [showDialog, setShowDialog] = useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(showDialog);
  const [regData, setRegData] = useState(initialShareholderData);

  const resetRegData = (data = {}) => {
    setRegData({
      ...initialShareholderData,
      ...data,
    });
  };

  const handleConfirmNavigation = () => {
    resetRegData();
    confirmNavigation();
  };

  return (
    <>
      <ConfirmationDialog
        show={showPrompt}
        onConfirm={handleConfirmNavigation}
        onCancel={cancelNavigation}
      />
      <ShareholdersForm
        setShowDialog={setShowDialog}
        regData={regData}
        setRegData={setRegData}
        resetRegData={resetRegData}
      />
    </>
  );
};

export default AddShareholder;
